<script lang="ts">
	let { showLegalLinks = true } = $props<{
		showLegalLinks?: boolean;
	}>();
</script>

<footer class="marketing-footer">
	<div class="container">
		<div class="footer-grid">
			<div class="footer-section">
				<h3>About LocallyGrown.net</h3>
				<p>
					Since 2002, we've been helping farmers markets and local food communities connect online.
					Our platform makes it easy to manage orders, coordinate deliveries, and grow your local
					food economy.
				</p>
			</div>
			<div class="footer-section">
				<h3>Quick Links</h3>
				<ul>
					<li><a href="/markets">Browse Markets</a></li>
					<li><a href="/markets/new">Start a Market</a></li>
					<li><a href="/features">Platform Features</a></li>
					<!-- <li><a href="/success-stories">Success Stories</a></li> -->
				</ul>
			</div>
			<div class="footer-section">
				<h3>Resources</h3>
				<ul>
					<li><a href="/faq/marketing">FAQ</a></li>
					<!-- <li><a href="/blog">Blog</a></li> -->
					<li><a href="/docs">Support</a></li>
					<!-- <li><a href="/contact">Contact Us</a></li> -->
				</ul>
			</div>
			{#if showLegalLinks}
				<div class="footer-section">
					<h3>Legal</h3>
					<ul>
						<li><a href="/legal/termsofuse">Terms of Use</a></li>
						<li><a href="/legal/privacy">Privacy Policy</a></li>
						<li><a href="/legal/dmca">DMCA</a></li>
					</ul>
				</div>
			{/if}
		</div>
		<div class="footer-bottom">
			<p>&copy; {new Date().getFullYear()} LocallyGrown.net, LLC. All rights reserved.</p>
		</div>
	</div>
</footer>

<style>
	.marketing-footer {
		background: var(--marketing-gradient-primary);
		color: var(--marketing-text-white);
		padding: 3rem 0 1rem;
		margin-top: 4rem;
	}

	.container {
		max-width: 1200px;
		margin: 0 auto;
		padding: 0 1.5rem;
	}

	.footer-grid {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
		gap: 2rem;
		margin-bottom: 2rem;
	}

	.footer-section h3 {
		margin-bottom: 1rem;
		color: var(--marketing-text-white);
		font-weight: 600;
	}

	.footer-section ul {
		list-style: none;
		padding: 0;
		margin: 0;
	}

	.footer-section a {
		color: rgba(255, 255, 255, 0.8);
		text-decoration: none;
		line-height: 1.8;
		transition: color 0.2s;
	}

	.footer-section a:hover {
		color: var(--marketing-text-white);
		text-decoration: underline;
	}

	.footer-section p {
		color: rgba(255, 255, 255, 0.9);
		line-height: 1.7;
	}

	.footer-bottom {
		text-align: center;
		padding-top: 2rem;
		border-top: 1px solid rgba(255, 255, 255, 0.2);
		color: rgba(255, 255, 255, 0.6);
	}

	@media (max-width: 768px) {
		.marketing-footer {
			padding: 2rem 0 1rem;
			margin-top: 2rem;
		}

		.footer-grid {
			grid-template-columns: 1fr;
			gap: 1.5rem;
		}

		.footer-section + .footer-section {
			padding-top: 1rem;
			border-top: 1px solid rgba(255, 255, 255, 0.1);
		}
	}
</style>
